export const DaysToDeliveryFieldsNames = {
	SameDay: {
		name: "deliverySameDay",
		displayName: "Same Day",
		beName: "delivery_same_day",
	},
	OneThreeDays: {
		name: "deliveryFromOneToThreeDays",
		displayName: "1-3 Days",
		beName: "delivery_from_one_to_three_days",
	},
	FourSevenDays: {
		name: "deliveryFromFourToSevenDays",
		displayName: "4-7 Days",
		beName: "delivery_from_four_to_seven_days",
	},
	EightFourteenDays: {
		name: "deliveryFromEightToFourteenDays",
		displayName: "8-14 Days",
		beName: "delivery_from_eight_to_fourteen_days",
	},
	FifteenThirtyDays: {
		name: "deliveryFromFifteenToThirtyDays",
		displayName: "15-30 Days",
		beName: "delivery_from_fifteen_to_thirty_days",
	},
	DaysOverThirty: {
		name: "daysOverThirty",
		displayName: "30+ Days",
		beName: "days_over_thirty",
	},
	ThirtyPlusDays: {
		name: "deliveryOverThirtyDays",
		displayName: "30+ Days",
		beName: "delivery_over_thirty_days",
	},
};
